import http from '../utils/fetch'
import qs from 'qs'

export default {
  info() {
    return http.get({
      url: 'v1/balance'
    })
  },

  applyWithdraw(amount) {
    return http.post({
      url: 'v1/balance/withdraw',
      data: qs.stringify({amount: amount})
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/balance.js